export const normalizeBasePath = (slug?: string | null): string => {
    if (!slug) {
        return '';
    }
    const trimmed = slug.replace(/^\/|\/$/g, '');
    return trimmed ? `/${trimmed}` : '';
};

const isAbsoluteUrl = (path: string) => /^(?:https?:)?\/\//.test(path);

const ensureLeadingSlash = (path: string) => (path.startsWith('/') ? path : `/${path}`);

export const withBasePath = (path = '', basePath = ''): string => {
    if (!path) {
        return basePath;
    }

    if (isAbsoluteUrl(path) || path.startsWith('data:') || path.startsWith('mailto:')) {
        return path;
    }

    if (path.startsWith('#')) {
        return path;
    }

    const normalizedPath = ensureLeadingSlash(path);
    return `${basePath}${normalizedPath}`;
};

export const getRelativeAssetPath = (path = ''): string => {
    if (!path) return '';
    if (isAbsoluteUrl(path) || path.startsWith('#') || path.startsWith('data:')) {
        return path;
    }
    return ensureLeadingSlash(path);
};

export { toAssetUrl as withBasePathForAssets } from './asset-url';
